/* eslint-disable no-self-assign */
/* eslint-disable no-var */
/* eslint-disable vars-on-top */
import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import UpdateTransactionModal from './UpdateTransactionModal';
import UTRModal from './UTRModal';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  tableHead: { backgroundColor: 'black' },
  tableHeadCell: { color: 'white' },
  tableBodyRow: { height: '50px' },
  // buttonFIlter: { borderColor: 'lightgray' },
});

function createData(
  transporterName,
  agentName,
  data,
  amount,
  utr,
  timestamp,
  status
) {
  return {
    transporterName,
    agentName,
    data,
    amount,
    utr,
    timestamp,
    status,
  };
}
var offset = 0;

export default function DenseTable({ balanceRequest, triggerRefresh, next }) {
  const classes = useStyles();

  const toIndianCurrency = num => {
    if (num) {
      const curr = num.toLocaleString('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
      return curr;
    }
    return 0;
  };
  const convertTimestamp = value => {
    const date = new Date(value);
    const convertedDate = `${date.getDate()}/${date.getMonth() +
      1}/${date.getFullYear()}  ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;

    return convertedDate;
  };
  const rows = balanceRequest?.map(data =>
    createData(
      data?.transporter_name,
      data?.agent_name,
      data,
      toIndianCurrency(data?.balance),
      data.utr,
      convertTimestamp(data.created_at),
      data.transaction_status
      // data?.data[2]
    )
  );
  const handlePrevious = () => {
    if (offset === 0) {
      offset = offset;
      triggerRefresh('all', offset, false);
    } else {
      offset -= 10;
      triggerRefresh('all', offset, false);
    }
  };
  const handleNext = () => {
    offset += 10;
    triggerRefresh('all', offset);
  };
  useEffect(() => {
    offset = 0;
  }, []);
  return (
    <div style={{ marginTop: '10px' }}>
      <TableContainer>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            margin: '10px',
          }}
        >
          <Button
            onClick={handlePrevious}
            disabled={offset === 0}
            startIcon={<ArrowBackIcon />}
          >
            Previous
          </Button>
          <Button
            onClick={handleNext}
            disabled={next}
            endIcon={<ArrowForwardIcon />}
          >
            Next
          </Button>
        </div>
        <Table
          className={classes.table}
          size="small"
          aria-label="a dense table"
        >
          <TableHead className={classes.tableHead}>
            <TableRow>
              <TableCell className={classes.tableHeadCell}>
                Transporter Name
              </TableCell>
              <TableCell className={classes.tableHeadCell} align="left">
                Agent
              </TableCell>
              <TableCell className={classes.tableHeadCell} align="center">
                Trip Details
              </TableCell>
              <TableCell className={classes.tableHeadCell} align="right">
                Settlement Amount
              </TableCell>
              <TableCell className={classes.tableHeadCell} align="center">
                UTR
              </TableCell>
              <TableCell className={classes.tableHeadCell} align="center">
                Date Time Stamp
              </TableCell>
              <TableCell className={classes.tableHeadCell} align="left">
                Status
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.map(row => (
              <TableRow className={classes.tableBodyRow} key={row.name}>
                <TableCell component="th" scope="row">
                  {row.transporterName}
                </TableCell>
                <TableCell align="left">{row.agentName}</TableCell>
                <TableCell align="center">
                  <UpdateTransactionModal data={row.data} />
                </TableCell>
                <TableCell align="right">{row.amount}</TableCell>
                <TableCell align="center">{row.utr}</TableCell>
                <TableCell align="center">{row.timestamp}</TableCell>
                <TableCell align="left">
                  <UTRModal
                    status={row.status}
                    data={row.data}
                    // updateStatus={value => updateStatus(value)}
                    triggerRefresh={value => triggerRefresh(value)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
